import React from 'react'
import PropTypes from 'prop-types'

import Card from '@components/card'

import {
  CloseIcon, Title, Subtitle, ButtonsContainer, TextContainer
} from './styles'

import PrimaryButton from '@components/inputs/button/primaryButton'
import SecondaryButton from '@components/inputs/button/secondaryButton'
import ConfirmationModal from '@components/modal/confirmationModal'

const LoanDevolutionModal = ({ setClose, open, onDevolution }) => {
  return (
    <ConfirmationModal isOpen={open}>
      <Card
        style={{
          flexDirection: 'column',
          width: '404px',
          height: 'auto',
          justifyContent: 'flex-start',
          padding: 0,
          position: 'relative',
        }}
      >
        <CloseIcon className="material-icons-outlined" onClick={setClose}>close</CloseIcon>
        <TextContainer>
          <Title> Confirmar a devolução deste empréstimo? </Title>
          <Subtitle>Esta ação não pode ser desfeita.</Subtitle>
        </TextContainer>
        <ButtonsContainer>
          <PrimaryButton
            style={{ width: '100%', height: '48px', }}
            onClick={onDevolution}
          >
            Devolver
          </PrimaryButton>
          <SecondaryButton
            style={{ width: '100%', height: '48px', }}
            onClick={setClose}
          >
            Cancelar
          </SecondaryButton>
        </ButtonsContainer>
      </Card>
    </ConfirmationModal>
  )
}

LoanDevolutionModal.propTypes = {
  setClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onDevolution: PropTypes.func.isRequired,
}

export default LoanDevolutionModal
